// utils.js

export const formatTime = (time) => {
    if (!time) return ""; // Handle undefined/null
    const [hours, minutes] = time.split(":"); // Split time by colon
    return `${hours}:${minutes}`; // Return only hours and minutes
  };
  
  export const formatDate = (date) => {
    if (!date) return ""; // Handle undefined/null
    const [year, month, day] = date.split("-"); // Split date by dashes
    return `${day}-${month}-${year}`; // Rearrange to day-month-year
  };
  

  export const calculateDuration = (startTime, endTime) => {
    const start = new Date("1970-01-01T" + startTime); // Parse to Date
    const end = new Date("1970-01-01T" + endTime); // Parse to Date

    // Calculate the difference in milliseconds
    const durationInMs = end - start;

    // Convert milliseconds to hours, minutes, and seconds
    const durationInSeconds = durationInMs / 1000;
    const durationInMinutes = durationInMs / (1000 * 60);
    const durationInHours = durationInMs / (1000 * 60 * 60);

    if (durationInHours >= 1) {
      // Return hours and minutes
      const hours = Math.floor(durationInHours);
      const minutes = Math.floor((durationInHours - hours) * 60);
      return `${hours}h ${minutes}min`;
    } else if (durationInMinutes >= 1) {
      // Return minutes and seconds
      const minutes = Math.floor(durationInMinutes);
      return `${minutes}min`;
    } else {
      // Return seconds
      const seconds = Math.floor(durationInSeconds);
      return `${seconds}s`;
    }
  };


  export   const renderStatus = (status) => {
    switch (status) {
      case "finish":
        return { text: "Términé", className: "bg-success" };
      case "en_attente":
        return { text: "En attente", className: "bg-warning" };
      default:
        return { text: status, className: "" }; // If no match, return original status and no class
    }
  };


  export   const  checkAge = (dob) =>{
    const dobDate = new Date(dob);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - dobDate.getFullYear();
    const m = currentDate.getMonth() - dobDate.getMonth();

    // If the birthday hasn't occurred yet this year, subtract 1 from the age
    if (m < 0 || (m === 0 && currentDate.getDate() < dobDate.getDate())) {
      age--;
    }

    // Return true if age is 18 or more, otherwise false
    return age >= 18;
  }
